import axios from 'axios'
import { getAPIUrl } from '../API'

export interface PropertyDetailsRequest {
  cmaid: number
  schemeNo: number
  sectionNo: number
}

export interface PropertyDetailsResponse {
  deedsOfficeID: string
  sgOffice: string
  cmaid: number
  schemeNo: number
  schemeName: string
  erfNo: string
  sG21Code: string
  allotment: string
  streetNo: string
  streetName: string
  complex: string
  subSuburb: string
  suburb: string
  municipality: string
  municipalityCode: string
  province: string
  provinceCode: string
  address: string
  type: string
  longitude: string
  latitude: string
  useCode: string
  erfUsage: string
  useCat: string
  erfExtent: string
  cadExtent: string
  zone: string
  zoneDesc: string
  owner: string
  ownerIDNo: string
  isParentErf: string
  ratepayer: string
  address1: string
  address2: string
  address3: string
  address4: string
  postCode: string
  munValue: string
  munValueYear: string
  rates: string
  siteOnly: string
  purchasePrice: string
  purchaseDate: string
  registeredDate: string
  titleDeed: string
  noPropOnDeed: string
  bondHolder: string
  bondAmount: string
  saleType: string
  saleStatus: string
  reportedListPrice: string
  reportedListDate: string
  listedBy: string
  showDate: string
  showPrice: string
  reportedSalePrice: string
  hideLocation: string
  reportedSaleDate: string
  saleReportedBy: string
  saleCapturedBy: string
  capturedCompany: string
  capturedDate: string
  showReportedSale: string
  saleReportedID: string
  saleReportedTime: string
  buyer: string
  svImgDate: string
  agentImgID: string
  isAgentsImg: string
  dataCapturedBy: string
  sourceOfInfo: string
  sectionNo: number | null
  flatNo: string
  planNo: string
  sectionExtent: string
  drawingExtent: string
  stUsage: string
  typeCat: string
  typeDesc: string
  rebate: string
  notes: string
  noSectionsOwned: string
}

export const getPropertyDetails: (
  options: PropertyDetailsRequest,
) => Promise<PropertyDetailsResponse> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/PropertyDetails`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return {
    ...(data.data as PropertyDetailsResponse),
    cmaid: parseInt(data.data.cmaid),
    schemeNo: parseInt(data.data.schemeNo),
    sectionNo: parseInt(data.data.sectionNo),
  }
}
